module.exports = __webpack_public_path__ + "img/WF_23_sm.2e2bf274.jpg";